import React from 'react'

// Modern chip-based Alerts filter tray (replaces the nested Ant submenu). Reuses the existing
// selection logic in index.jsx by synthesizing the same { key, keyPath } events it expects.
const TYPE_OPTS = (isSpecial) => [
  { label: 'Automatic', key: 'Automatic' },
  { label: 'Manual', key: 'Manual' },
  { label: 'Tablet', key: 'Tablet' },
  { label: 'Near Miss', key: 'FA/NM' },
  ...(isSpecial ? [{ label: 'Debug', key: 'Debug' }] : []),
]
const LEVEL_OPTS = [
  { label: 'No Hazard', key: 'No Hazard' },
  { label: 'Lights', key: 'Lights' },
  { label: 'Sirens', key: 'Sirens' },
]

export const AlarmFilters = ({ units = [], appVersions = [], isSpecial, selectedKeys = [], onClick }) => {
  const fire = (key, category) => onClick({ key, keyPath: [key, category, 'filters'] })
  // selectedKeys is a list of [key, category] pairs. Match BOTH so a Vehicle and a ROADZ
  // Device that share a name string (e.g. "LTN0028") don't highlight/toggle together.
  const on = (key, cat) => selectedKeys.some((sk) => sk[0] === key && sk[1] === cat)

  const Chip = ({ label, k, cat }) => (
    <button type="button" className={`rz-af-chip${on(k, cat) ? ' on' : ''}`} onClick={() => fire(k, cat)}>{label}</button>
  )

  // get_units returns [vehicle_name, serial]. Split into a Vehicle filter (by name) and a
  // ROADZ Device filter (by serial), each de-duplicated. Vehicle-only = that vehicle's
  // alerts (any device); Device-only = all that device's data (any vehicle); both = narrowed.
  const vehicleOpts = [...new Set(units.map((u) => u[0]).filter(Boolean))].sort().map((n) => ({ label: n, key: n }))
  const deviceOpts = [...new Set(units.map((u) => u[1]).filter(Boolean))].sort().map((s) => ({ label: s, key: s }))

  const Section = ({ title, opts, cat }) => (
    <section className="rz-af-sec">
      <div className="rz-af-lbl">{title}</div>
      <div className="rz-af-chips">
        {opts.map((o) => <Chip key={o.key} label={o.label} k={o.key} cat={cat} />)}
      </div>
    </section>
  )

  return (
    <div className="rz-af">
      <Section title="Vehicle" opts={vehicleOpts} cat="vehicleFilters" />
      <Section title="ROADZ Device" opts={deviceOpts} cat="deviceFilters" />
      <Section title="Report Type" opts={TYPE_OPTS(isSpecial)} cat="triggerTypeFilters" />
      <Section title="Hazard Level" opts={LEVEL_OPTS} cat="triggerLevelFilters" />
      {appVersions.length > 0 && (
        <Section title="App Version" opts={appVersions.map((v) => ({ label: v, key: v }))} cat="appVersionFilters" />
      )}
    </div>
  )
}

export default AlarmFilters
